'use strict';

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// URLSearchParams polyfill for iOS 10 and IE 11
try { if (new URLSearchParams('q=%2B').get('q') !== '+') throw {}; }
catch (error) {
  // iOS 10 has a broken global native constructor, so we have to
  // initialize it before including the polyfill.
  // https://github.com/WebReflection/url-search-params#ios-10--other-platforms-bug
  window.URLSearchParams = void 0;
  window.URLSearchParams = require('url-search-params');
}

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 216
// module chunks = 11